export function toLowerCase(str) {
    return String(str).toLowerCase();
}
